import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { TranslateService } from '@ngx-translate/core';
import { Option } from '@vi-iot/ui/components/dropdown-autocomplete/dropdown-autocomplete.component';
import { Subject, takeUntil } from 'rxjs';
import { ViLoaderComponent } from '../../../../../projects/ui';
import {
  ServiceTicket,
  ServiceTicketErrorDetails,
  ServiceTicketStore,
} from '../../../../@store/service-ticket';
import { CommonStandaloneModule } from '../../../common-standalone.module';
import { ServiceTicketBoilerSerialFieldComponent } from './service-ticket-boiler-serial-field/service-ticket-boiler-serial-field.component';
import { ServiceTicketCallSupportComponent } from './service-ticket-call-support/service-ticket-call-support.component';
import { ServiceTicketDetailedInformationComponent } from './service-ticket-detailed-information/service-ticket-detailed-information.component';
import { ServiceTicketErrorFieldComponent } from './service-ticket-error-field/service-ticket-error-field.component';
import { ServiceTicketExtraInformationComponent } from './service-ticket-extra-information/service-ticket-extra-information.component';
import { ServiceTicketOtherErrorCodeFieldComponent } from './service-ticket-other-error-code-field/service-ticket-other-error-code-field.component';

@Component({
  selector: 'app-service-ticket-page-create',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ServiceTicketBoilerSerialFieldComponent,
    ServiceTicketErrorFieldComponent,
    ServiceTicketCallSupportComponent,
    ServiceTicketOtherErrorCodeFieldComponent,
    ServiceTicketDetailedInformationComponent,
    LetDirective,
    ViLoaderComponent,
    ServiceTicketExtraInformationComponent,
  ],
  templateUrl: './service-ticket-page-create.component.html',
  styleUrls: ['./service-ticket-page-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketPageCreateComponent implements OnInit, OnDestroy {
  CreatePageSteps = ServiceTicket.CreatePageSteps;
  deviceErrors: Option[];
  detailsInDifferentLanguage = false;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public serviceTicketStore: ServiceTicketStore,
    protected translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.serviceTicketStore.allBoilerDeviceErrorDetails$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((errorDetails: ServiceTicketErrorDetails) => {
        this.detailsInDifferentLanguage = errorDetails?.detailsInDifferentLanguage;

        let _deviceErrors: Option[] = !errorDetails?.details
          ? []
          : errorDetails?.details.map((entry) => ({
              value: entry.faultCode,
              viewValue: entry.text,
            }));
        this.deviceErrors = _deviceErrors;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
